var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.9606 8.91999L22.0006 16.4C17.4006 18.12 13.6406 23.56 13.6406 28.48V58.2C13.6406 62.92 16.7607 69.12 20.5607 71.96L37.7606 84.8C43.4006 89.04 52.6805 89.04 58.3205 84.8L75.5206 71.96C79.3206 69.12 82.4405 62.92 82.4405 58.2V28.48C82.4405 23.56 78.6806 18.12 74.0806 16.4L54.1206 8.91999C50.7206 7.67999 45.2806 7.67999 41.9606 8.91999Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5991 45.2001C47.6791 45.2001 47.7591 45.2001 47.8391 45.2001H47.9191H47.9991C52.5991 45.0401 56.1991 41.3201 56.2391 36.6801C56.2391 31.9601 52.3992 28.1201 47.6792 28.1201C42.9592 28.1201 39.1191 31.9601 39.1191 36.6801C39.1991 41.2801 42.7991 45.0401 47.5991 45.2001Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7606 53.6402C51.9206 50.4402 44.0806 50.4402 39.2006 53.6402C36.9606 55.1602 35.6406 57.3202 35.6406 59.5602C35.6406 61.8402 36.9206 63.9202 39.2006 65.4402C41.6406 67.0402 44.8006 67.8802 47.9606 67.8802C51.1206 67.8802 54.3206 67.0802 56.7206 65.4402C58.9606 63.9202 60.2806 61.7602 60.2806 59.5202C60.3206 57.2402 59.0406 55.1602 56.7606 53.6402Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9132b3e625b2a298558e5d394e23eb77.svg";
export { ForwardRef as ReactComponent };